import React from 'react';
import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { isYes, isRelationshipToVeteran } from '../../../../utils/helpers';
import { IncomeAssetStatementFormAlert } from '../../../../components/FormAlerts';
import content from '../../../../utils/content.json';

const WhatTransferredAssets = () => (
  <va-additional-info trigger="How to tell if you have transferred assets">
    <p>You transferred assets if you made any of these transactions:</p>
    <ul>
      <li>You gave away money or property</li>
      <li>You sold a home that isn’t your primary residence</li>
      <li>
        You purchased an annuity, such as an insurance policy that pays you
        monthly or annually
      </li>
      <li>You put money or property into a trust</li>
    </ul>
  </va-additional-info>
);

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['financial-info-transferred-title']),
    transferredAssets: {
      ...yesNoUI(),
      'ui:options': {
        updateSchema: formData => {
          let title = '';
          if (isRelationshipToVeteran(formData) === 'spouse') {
            title = content['financial-info-transferred-question-spouse'];
          } else if (isRelationshipToVeteran(formData) === 'child') {
            title = content['financial-info-transferred-question-child'];
          } else if (isRelationshipToVeteran(formData) === 'custodian') {
            title = content['financial-info-transferred-question-custodian'];
          }
          return {
            title,
          };
        },
      },
    },
    incomeAssetStatementFormAlert: {
      'ui:description': IncomeAssetStatementFormAlert,
      'ui:options': {
        hideIf: formData => !isYes(formData?.transferredAssets),
        displayEmptyObjectOnReview: true,
      },
    },
    'view:whatTransferredAssets': {
      'ui:description': WhatTransferredAssets,
      'ui:options': {
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['transferredAssets'],
    properties: {
      transferredAssets: yesNoSchema,
      incomeAssetStatementFormAlert: {
        type: 'object',
        properties: {},
      },
      'view:whatTransferredAssets': {
        type: 'object',
        properties: {},
      },
    },
  },
};
